export default "__VITE_ASSET__XG2CPvjt__"